import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice.js';
import collectorReducer from './collectorSlice.js';
import adminReducer from './adminSlice.js';
import hearingReducer from './hearingSlice.js';
import providerReducer from './providerSlice.js';
import paymentRedeemerReducer from './paymentRedeemerSlice.js';
import loginReducer from './loginSlice.js';
import recordDetailsReducer from './recordDetailsSlice.js';
import headerReducer from './headerSlice.js';
import hearingRecordDetailsReducer from './hearingRecordDetailsSlice.js';
import tokenTestReducer from './tokenTestSlice.js';
import recordsTableReducer from './recordsTableSlice.js';
import scheduleCalendarReducer from './scheduleCalendarSlice.js';
import userProfileReducer from './userProfileSlice.js';
import manualRecordFormReducer from './manualRecordFormSlice.js';
import historyTabReducer from './historyTabSlice.js';
import recordsPageReducer from './recordsPageSlice.js';
import exportReportReducer from './exportReportSlice.js';
import manageUsersReducer from './manageUsersSlice.js';
import assignmentSummaryReducer from './assignmentSummarySlice.js';
import summaryReducer from './summarySlice.js';
import duplicateRecordsTableReducer from './duplicateRecordsTableSlice.js';
import hearingCalendarReducer from './hearingCalendarSlice.js';
import registerUserFormReducer from './registerUserFormSlice.js';

const store = configureStore({
  reducer: {
    auth: authReducer,
    collector: collectorReducer,
    admin: adminReducer,
    hearing: hearingReducer,
    provider: providerReducer,
    paymentRedeemer: paymentRedeemerReducer,
    login: loginReducer,
    recordDetails: recordDetailsReducer,
    header: headerReducer,
    hearingRecordDetails: hearingRecordDetailsReducer,
    tokenTest: tokenTestReducer,
    recordsTable: recordsTableReducer,
    scheduleCalendar: scheduleCalendarReducer,
    userProfile: userProfileReducer,
    manualRecordForm: manualRecordFormReducer,
    historyTab: historyTabReducer,
    recordsPage: recordsPageReducer,
    exportReport: exportReportReducer,
    manageUsers: manageUsersReducer,
    assignmentSummary: assignmentSummaryReducer,
    summary: summaryReducer,
    duplicateRecordsTable: duplicateRecordsTableReducer,
    hearingCalendar: hearingCalendarReducer,
    registerUserForm: registerUserFormReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['admin/setSelectedFile'],
        ignoredPaths: [
          'admin.selectedFile',
          'scheduleCalendar.currentDate',
          'scheduleCalendar.selectedDate',
        ],
      },
    }),
});

export default store;
